__turbopack_context__.v({
  "menu__item": "user-drawer-nav-module-scss-module__g6yKUa__menu__item",
  "menu__item___border": "user-drawer-nav-module-scss-module__g6yKUa__menu__item___border",
  "nav__head": "user-drawer-nav-module-scss-module__g6yKUa__nav__head",
  "nav__menu": "user-drawer-nav-module-scss-module__g6yKUa__nav__menu",
  "user__detail": "user-drawer-nav-module-scss-module__g6yKUa__user__detail",
  "user__get_gold": "user-drawer-nav-module-scss-module__g6yKUa__user__get_gold",
  "user__name": "user-drawer-nav-module-scss-module__g6yKUa__user__name",
  "user__nav__container": "user-drawer-nav-module-scss-module__g6yKUa__user__nav__container",
  "user__trail": "user-drawer-nav-module-scss-module__g6yKUa__user__trail",
});
